import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';  // Tailwind CSS 스타일을 여기서 import
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);